import { registerBlockType } from '@wordpress/blocks'
import { PanelBody, Path, Rect, SVG } from '@wordpress/components'
import { InspectorControls } from '@wordpress/block-editor'
import { Fragment } from '@wordpress/element'
import MetaToggle from '../Meta/MetaToggle'
import MetaSelect from '../Meta/MetaSelect'
import MetaTextField from '../Meta/MetaTextField'
import Privacy from '../Components/SelectOptions/Privacy'
import Service from '../Components/SelectOptions/Service'

registerBlockType('usna1978/classmate-hidden-details', {
  title: 'Classmate: Hidden Details',
  description: 'A box with details that are not readily viewable to the public.',
  // eslint-disable-next-line react/jsx-pascal-case
  icon: <SVG viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><Path d='M0,0h24v24H0V0z' fill='none' /><Path d='M20,4H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6C22,4.9,21.1,4,20,4z M20,18H4V6h16V18z' /><Rect x='6' y='10' width='2' height='2' /><Rect x='6' y='14' width='8' height='2' /><Rect x='16' y='14' width='2' height='2' /><Rect x='10' y='10' width='8' height='2' /></SVG>,
  category: 'formatting',
  attributes: {
    academicMajor: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_academic_major'
    },
    napsGrad: {
      type: 'boolean',
      source: 'meta',
      meta: 'usna1978_naps_grad'
    },
    foundationRcpt: {
      type: 'boolean',
      source: 'meta',
      meta: 'usna1978_foundation_rcpt'
    },
    service1: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_service_1'
    },
    service1other: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_service_1_other'
    },
    service2: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_service_2'
    },
    service2other: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_service_2_other'
    },
    service3: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_service_3'
    },
    service3other: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_service_3_other'
    },
    designator1: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_designator_1'
    },
    designator2: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_designator_2'
    },
    designator3: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_designator_3'
    },
    retired: {
      type: 'boolean',
      source: 'meta',
      meta: 'usna1978_designator_1'
    },
    yearsServed: {
      type: 'integer',
      source: 'meta',
      meta: 'usna1978_years_served'
    },
    terminalRank: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_terminal_rank'
    }
  },

  /**
   * The edit function describes the structure of your block in the context of
   * the editor. This represents what the editor will render when the block is
   * used.
   *
   * The "edit" property must be a valid function.
   *
   * @link https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/
   */
  edit ({ attributes }) {
    const { service1, service2, service3 } = attributes

    return (
      <Fragment>
        <InspectorControls>
          <PanelBody>
            Get ready for some fields here.
          </PanelBody>
        </InspectorControls>
        <div className='panel panel-default'>
          <div className='panel-heading'>
            <strong>Hidden Details</strong>
          </div>
          <div className='panel-body'>
            <table className='borderless'>
              <tbody>
                <tr><td>Academic Major at USNA</td><td><MetaTextField fieldName='usna1978_academic_major' /></td></tr>
                <tr><td>Naps Graduate</td><td><MetaToggle fieldName='usna1978_naps_grad' /></td></tr>
                <tr><td>Foundation Scholarship Recipient</td><MetaToggle fieldName='usna1978_foundation_rcpt' /></tr>
                <tr>
                  <td>Service 1</td>
                  <td>
                    <MetaSelect
                      fieldName='usna1978_service_1'
                      options={Service}
                    />
                    {(() => {
                      return (service1 === 'Other') ? <MetaTextField fieldName='usna1978_service_1_other' /> : ''
                    })()}
                  </td>
                </tr>
                <tr><td>Designator 1</td><td><MetaTextField fieldName='usna1978_designator_1' /></td></tr>
                <tr>
                  <td>Service 2</td>
                  <td>
                    <MetaSelect
                      fieldName='usna1978_service_2'
                      options={Service}
                    />
                    {(() => {
                      return (service2 === 'Other') ? <MetaTextField fieldName='usna1978_service_2_other' /> : ''
                    })()}
                  </td>
                </tr>
                <tr><td>Designator 2</td><td><MetaTextField fieldName='usna1978_designator_2' /></td></tr>
                <tr>
                  <td>Service 3</td>
                  <td>
                    <MetaSelect
                      fieldName='usna1978_service_3'
                      options={Service}
                    />
                    {(() => {
                      return (service3 === 'Other') ? <MetaTextField fieldName='usna1978_service_3_other' /> : ''
                    })()}
                  </td>
                </tr>
                <tr><td>Designator 3</td><td><MetaTextField fieldName='usna1978_designator_3' /></td></tr>
                <tr><td>Retired</td><td><MetaToggle fieldName='usna1978_retired' /></td></tr>
                <tr><td>Years Served</td><td><MetaTextField fieldName='usna1978_years_served' /></td></tr>
                <tr><td>Terminal Rank</td><td><MetaTextField fieldName='usna1978_terminal_rank' /></td></tr>
                <tr><td>Additional Degree 1</td><td><MetaTextField fieldName='usna1978_add_degree_1' /></td></tr>
                <tr><td>University</td><td><MetaTextField fieldName='usna1978_add_degree_1_loc' /></td></tr>
                <tr><td>Additional Degree 2</td><td><MetaTextField fieldName='usna1978_add_degree_2' /></td></tr>
                <tr><td>University</td><td><MetaTextField fieldName='usna1978_add_degree_2_loc' /></td></tr>
                <tr><td>Additional Degree 3</td><td><MetaTextField fieldName='usna1978_add_degree_3' /></td></tr>
                <tr><td>University</td><td><MetaTextField fieldName='usna1978_add_degree_3_loc' /></td></tr>
                <tr>
                  <td>Profile Privacy</td>
                  <td>
                    <MetaSelect
                      fieldName='usna1978_profile_privacy'
                      options={Privacy}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Fragment>
    )
  },

  /**
   * The save function defines the way in which the different attributes should
   * be combined into the final markup, which is then serialized by Gutenberg
   * into post_content.
   *
   * The "save" property must be specified and must be a valid function.
   *
   * @link https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/
   */
  save () {
    return null
  }
})
